import Avatar from "@/assets/images/avatar.png";
import EmptyState from "../EmptyState";
import sanitize from "sanitize-html";
import { sanitizeHtmlOptions } from "@/lib/utils";
import { MathJax } from "better-react-mathjax";

type Props = {
  announcements: string[];
};

const LessonAnnouncements = ({ announcements }: Props) => {
  if (!announcements?.length)
    return (
      <EmptyState>
        <div className="max-w-[240px] font-semibold text-[#2C323C]">
          No announcements
        </div>
      </EmptyState>
    );

  return (
    <div className="grid gap-12">
      {announcements.map((announcement, index) => (
        <Announcement key={index} announcement={announcement} />
      ))}
    </div>
  );
};

const Announcement = ({ announcement }: { announcement: string }) => {

  return (
    <div className="grid gap-2">
      <div className="flex items-center gap-2 mb-1">
        <img src={Avatar} className="h-[45px] w-[45px] rounded-full" alt="" />
        <p className="font-medium font-display text-primary">
          Instructor
        </p>
      </div>
      <MathJax>
        <div
          className="max-w-[850px] text-[#495364]"
          dangerouslySetInnerHTML={{
            __html: sanitize(announcement, sanitizeHtmlOptions),
          }}
        />
      </MathJax>
    </div>
  );
};

export default LessonAnnouncements;
